const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

const TIMING = {
  CART_DEBOUNCE_MS: 300,
  BULK_ADD_DELAY_MS: 250,
  VIEW_TRANSITION_CLEANUP_MS: 500,
  DRAWER_ANIMATION_MS: 400,
  ANNOUNCER_BAR_ANIMATION_MS: 250,
};

const INTERSECTION = {
  SCROLL_ANIMATION_ROOT_MARGIN: '0px 0px -50px 0px',
  RECOMMENDATIONS_ROOT_MARGIN: '0px 0px 400px 0px',
};
